import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-4">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
        <li>
          <a href="/" className="hover:text-primary-600 transition-colors duration-200">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </a>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.href && idx < items.length - 1 ? (
              <a href={item.href} className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {item.label}
              </a>
            ) : (
              <span className={`whitespace-nowrap ${idx === items.length - 1 ? 'text-foreground-800 font-medium' : ''}`}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}